/*
 * fn: createIcon
 *
 * Creates a memoized icon Component with boilerplate code
 *
 */
import { type FC, memo, type ReactNode, type SVGProps } from 'react'

type IconComponent = FC<SVGProps<SVGSVGElement>>

export const createIcon = (name: string, render: (props: SVGProps<SVGSVGElement>) => ReactNode): IconComponent => {
  const Component = memo(render)
  Component.displayName = name
  return Component
}
